import { fromZonedTime, toZonedTime } from 'date-fns-tz';
import { format } from 'date-fns';

export function dateToIsoString(date: string, timeZone: string) {
  return fromZonedTime(`${date}T00:00:00`, timeZone).toISOString();
}

export function isoStringToDate(isoString: string, timeZone: string) {
  const zonedDate = toZonedTime(isoString, timeZone);
  return format(zonedDate, 'yyyy-MM-dd');
}
